module.exports = __webpack_public_path__ + "static/media/dear-wanderer@2x.f572dcc7.png";